import * as React from 'react';
import Checkbox from 'components/Checkbox';
import Menu from 'components/Menu';
import MenuItem from 'components/MenuItem';
import Input from 'components/Input';
import LayerTrigger from 'components/LayerTrigger';
import SettingsStore from 'stores/SettingsStore';
import EventTracking from 'lib/EventTracking';

import { without } from 'lodash';

import './styles/GradeLevelPicker.scss';

type Props = {
  onClose: (gradeLevels: string[]) => void;
  initialGrades: string[];
};

type Grade = {
  name: string;
  short_name: string;
  code: string;
};

type State = {
  selectedGrades: string[];
};

class GradeLevelPicker extends React.Component<Props, State> {
  state: State = {
    selectedGrades: [],
  };

  componentDidMount() {
    if (this.props.initialGrades) {
      this.setState({ selectedGrades: this.props.initialGrades });
    }
  }

  isSelected = (gradeCode: string) => {
    return this.state.selectedGrades.includes(gradeCode);
  };

  toggleGrade = (gradeCode: string) => {
    const { selectedGrades } = this.state;
    if (this.isSelected(gradeCode)) {
      this.setState({ selectedGrades: without(selectedGrades, gradeCode) });
    } else {
      this.setState({ selectedGrades: selectedGrades.concat(gradeCode) });
    }
  };

  menuItemForGrade = (grade: Grade) => {
    return (
      <MenuItem
        className="GradeLevelPicker-menuItem"
        menuKey={grade.code}
        onSelect={this.toggleGrade}>
        <Checkbox checked={this.isSelected(grade.code)} label={grade.name} />
      </MenuItem>
    );
  };

  onHide = () => {
    EventTracking.tap(this.context.eventScreenName || 'grade_level_picker', 'save_grade_level', {
      grades: this.state.selectedGrades,
    });
    this.props.onClose(this.state.selectedGrades);
  };

  render() {
    const { selectedGrades } = this.state;
    const menu = (
      <Menu data-test="gradePickerMenu" className="GradeLevelPicker-menu" hideOnSelect={false}>
        {SettingsStore.getSetting('grades').map(this.menuItemForGrade)}
      </Menu>
    );

    let gradeLevelText = '';
    if (selectedGrades.length > 0) {
      gradeLevelText = selectedGrades
        .map(code => {
          const grade = SettingsStore.getGradeLevelForCode(code);
          return grade.short_name;
        })
        .join(', ');
    }

    return (
      <LayerTrigger
        layer={menu}
        data-test="gradeLevelLayer"
        trigger="click"
        placement="bottom"
        alignment="middle"
        onHide={this.onHide}>
        <Input
          className="GradeLevelPicker-input"
          data-test="GradeLevelPicker-input"
          readOnly
          value={gradeLevelText}
          placeholder="Select a grade"
        />
      </LayerTrigger>
    );
  }
}

export default GradeLevelPicker;
